<template>
  <div class="uk-child-width-1-2@m" uk-grid>
    <div>
      <div class="uk-inline uk-dark">
        <a href="https://ebiznow.co.kr">
          <img src="@/assets/images/market_demo.png" width="400" height="300" alt="">
          <div class="uk-position-center">
            <span uk-icon="icon: link; ratio: 3.5"></span>
          </div>
        </a>
      </div>
    </div>
    <div>
      <div class="uk-inline uk-dark">
        <a href="https://celeb-247.com/">
          <img src="@/assets/images/celeb_demo.png" width="400" height="300" alt="">
          <div class="uk-position-center">
            <span uk-icon="icon: link; ratio: 3.5"></span>
          </div>
        </a>
      </div>
    </div>
  </div>
  <div class="uk-child-width-1-2@m uk-margin-large-top" uk-grid>
    <div>
      <div class="uk-inline uk-dark">
        <a href="https://www.cos-247.com/">
          <img src="@/assets/images/cos_demo.png" width="400" height="300" alt="">
          <div class="uk-position-center">
            <span uk-icon="icon: link; ratio: 3.5"></span>
          </div>
        </a>
      </div>
    </div>
    <div>
      <div class="uk-inline uk-dark">
        <a href="hhttps://www.cyglobal.net/">
          <img src="@/assets/images/cy_demo.png" width="400" height="300" alt="">
          <div class="uk-position-center">
            <span uk-icon="icon: link; ratio: 3.5"></span>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>